__turbopack_context__.v({
  "full_lineup": "lineup-module-scss-module__tu7BRG__full_lineup",
  "lineup": "lineup-module-scss-module__tu7BRG__lineup",
  "lineupFilters": "lineup-module-scss-module__tu7BRG__lineupFilters",
  "name": "lineup-module-scss-module__tu7BRG__name",
  "people": "lineup-module-scss-module__tu7BRG__people",
  "person": "lineup-module-scss-module__tu7BRG__person",
  "photograph": "lineup-module-scss-module__tu7BRG__photograph",
});
